import React, { useState } from "react";
import "../Styles/GlobalNetwork.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ApiService from "../nhrc_apis/ApiService";

const JobsFair = () => {

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    organization_name: "",
    contact_number: "",
    contact_email: "",
    banner_image: "",
    start_date: "",
    end_date: "",
    start_time: "",
    end_time: "",
    location: "",
  });

  const [bannerFile, setBannerFile] = useState(null);
  const [bannerPreview, setBannerPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (files && files[0]) {
      setBannerFile(files[0]);
      setBannerPreview(URL.createObjectURL(files[0]));
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const validateForm = () => {
    if (!formData.title.trim()) {
      toast.error("⚠️ Job Fair Title is required!");
      return false;
    }
    if (!formData.description.trim()) {
      toast.error("⚠️ Short Description is required!");
      return false;
    }
    if (!formData.organization_name.trim()) {
      toast.error("⚠️ Organization Name is required!");
      return false;
    }
    if (!formData.contact_number.trim()) {
      toast.error("⚠️ Contact Number is required!");
      return false;
    }
    if (!formData.contact_email.trim()) {
      toast.error("⚠️ Contact Email is required!");
      return false;
    }
    if (!bannerFile) {
      toast.error("⚠️ Banner Image is required!");
      return false;
    }
    if (!formData.start_date) {
      toast.error("⚠️ Start Date is required!");
      return false;
    }
    if (!formData.end_date) {
      toast.error("⚠️ End Date is required!");
      return false;
    }
    if (!formData.start_time) {
      toast.error("⚠️ Start Time is required!");
      return false;
    }
    if (!formData.end_time) {
      toast.error("⚠️ End Time is required!");
      return false;
    }
    if (!formData.location.trim()) {
      toast.error("⚠️ Location is required!");
      return false;
    }
    return true;
  };

  /* ─────────────────────────────────────────
     UPLOAD BANNER — ✅ FIXED: now includes membership_id + file_type
     (the /upload/ endpoint requires these — confirm exact names from
     your 422 error's expanded "detail" array)
  ───────────────────────────────────────── */
  const uploadBanner = async () => {
    try {
      const fd = new FormData();
      fd.append("file", bannerFile);
      fd.append("membership_id", "job_fair");
      fd.append("file_type", "job_fair_banner");

      const response = await ApiService.UploadAPI.uploadFile(fd);

      console.log("Upload Response:", response.data);

      const fileUrl =
        response.data?.file_url ||
        response.data?.fileUrl ||
        response.data?.url ||
        response.data?.file_path ||
        "";

      if (!fileUrl) {
        toast.error("❌ Banner upload failed — no URL returned.");
        return null;
      }

      return fileUrl;

    } catch (error) {
      console.error("Banner Upload Error:", error);
      console.error("Full validation detail:", error?.response?.data?.detail);
      const msg =
        error?.response?.data?.detail ||
        "Banner image upload failed.";
      toast.error(`❌ ${JSON.stringify(msg)}`);
      return null;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setLoading(true);

    try {
      const bannerUrl = await uploadBanner();
      if (bannerUrl === null) {
        setLoading(false);
        return;
      }

      const payload = {
        service_id: 1,
        title: formData.title,
        description: formData.description,
        organization_name: formData.organization_name,
        contact_number: formData.contact_number,
        contact_email: formData.contact_email,
        banner_image: bannerUrl,
        start_date: formData.start_date,
        end_date: formData.end_date,
        start_time: formData.start_time,
        end_time: formData.end_time,
        location: formData.location,
      };

      console.log("Submitting Job Fair Payload:", payload);

      await ApiService.JobFairAPI.createJobFair(payload);

      toast.success("🎉 Job Fair created successfully!");

      setFormData({
        title: "",
        description: "",
        organization_name: "",
        contact_number: "",
        contact_email: "",
        banner_image: "",
        start_date: "",
        end_date: "",
        start_time: "",
        end_time: "",
        location: "",
      });
      setBannerFile(null);
      setBannerPreview(null);

    } catch (error) {
      console.error("Create Job Fair Error:", error);
      const msg =
        error?.response?.data?.detail ||
        error?.response?.data?.message ||
        "Failed to create job fair.";
      toast.error(`❌ ${msg}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mb-5">
      <ToastContainer position="top-right" autoClose={3000} />

      <h4 className="mb-4 text-danger fw-bold text-center">
        NHRC - Job & Jobfairs (Admin)
      </h4>

      <form
        className="p-3 border rounded shadow-sm bg-white"
        onSubmit={handleSubmit}
      >

        <div className="d-flex gap-4">
          <div className="mb-3" style={{ width: "50%" }}>
            <label className="form-label">Job Fair Title*</label>
            <input
              type="text"
              name="title"
              value={formData.title}
              onChange={handleChange}
              className="form-control"
              placeholder="Event Title"
            />
          </div>

          <div className="mb-3" style={{ width: "50%" }}>
            <label className="form-label">Short Description*</label>
            <input
              type="text"
              name="description"
              value={formData.description}
              onChange={handleChange}
              className="form-control"
            />
          </div>
        </div>

        <div className="d-flex gap-4">
          <div className="mb-3" style={{ width: "50%" }}>
            <label className="form-label">Organization Name*</label>
            <input
              type="text"
              name="organization_name"
              value={formData.organization_name}
              onChange={handleChange}
              className="form-control"
              placeholder="Organization Name"
            />
          </div>

          <div className="mb-3" style={{ width: "50%" }}>
            <label className="form-label">Contact Number*</label>
            <input
              type="text"
              name="contact_number"
              value={formData.contact_number}
              onChange={handleChange}
              className="form-control"
              placeholder="Contact Number"
            />
          </div>
        </div>

        <div className="d-flex gap-4">
          <div style={{ width: "50%" }}>
            <label className="form-label">Contact Email*</label>
            <input
              type="email"
              name="contact_email"
              value={formData.contact_email}
              onChange={handleChange}
              className="form-control"
              placeholder="Contact Email"
            />
          </div>

          <div style={{ width: "50%" }}>
            <label className="form-label">Upload Banner Img*</label>
            <input
              type="file"
              accept="image/jpeg,image/jpg,image/png,image/webp"
              className="form-control"
              onChange={handleChange}
            />
            <div
              className="d-flex justify-content-between"
              style={{ color: "#333", fontSize: "0.7rem" }}
            >
              <p>W350 x H300</p>
              <p>Upload JPG/PNG Minimum 1 To 2MB</p>
            </div>
            {bannerPreview && (
              <img
                src={bannerPreview}
                alt="Banner Preview"
                style={{
                  width: "100%",
                  maxHeight: "150px",
                  objectFit: "cover",
                  borderRadius: "6px",
                  marginTop: "4px",
                }}
              />
            )}
          </div>
        </div>

        <div className="row mt-2">
          <div className="col-md-6 mb-3">
            <label className="form-label">Start Date*</label>
            <input
              type="date"
              name="start_date"
              value={formData.start_date}
              onChange={handleChange}
              className="form-control"
            />
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">End Date*</label>
            <input
              type="date"
              name="end_date"
              value={formData.end_date}
              onChange={handleChange}
              className="form-control"
            />
          </div>
        </div>

        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label">Start Time*</label>
            <input
              type="time"
              name="start_time"
              value={formData.start_time}
              onChange={handleChange}
              className="form-control"
            />
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">End Time*</label>
            <input
              type="time"
              name="end_time"
              value={formData.end_time}
              onChange={handleChange}
              className="form-control"
            />
          </div>
        </div>

        <div className="mb-3">
          <label className="form-label">Location*</label>
          <input
            type="text"
            name="location"
            value={formData.location}
            onChange={handleChange}
            className="form-control"
            placeholder="Location"
          />
        </div>

        <div>
          <button
            type="submit"
            className="btn btn-success px-5"
            disabled={loading}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                />
                Submitting...
              </>
            ) : (
              "SUBMIT"
            )}
          </button>
        </div>

      </form>
    </div>
  );
};

export default JobsFair;